import React, { useEffect, useState } from "react";
import SelfImageMessage from "src/components/message/SelfImageMessage";
import GoalGallerySlider from "./GoalGallerySlider";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import JournalImageList from "src/components/_dashboard/journalPrompt/JournalImageList";
import { SelfImageListApi } from "src/DAL/JournalPrompts/JournalPrompts";
import JournalMessage from "src/components/message/JournalMessage";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

function JournalPrompts(props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [goalStatementQuestions, setGoalStatementQuestions] = useState([]);
  const [goalStatementGallery, setGoalStatementGallery] = useState([]);
  const [replies, setreplies] = useState([]);

  const getGoalStatementList = async () => {
    const result = await SelfImageListApi();
    if (result.code === 200) {
      setGoalStatementQuestions(result.self_image_question);
      let replyArray = [];
      let replyObject = {};
      result?.reply.map((reply, index) => {
        replyObject = {
          comment: reply?.message,
          createdAt: reply?.createdAt,
          image: reply?.image,
          audio_file: reply?.audio_file,
        };
        replyArray.push(replyObject);
      });

      setreplies(replyArray);
      let galleryArray = [];
      let galleryObject = {};
      result?.self_image_gallery.map((gallery, index) => {
        galleryObject = {
          original: s3baseUrl + gallery?.thumbnail_1,
          thumbnail: s3baseUrl + gallery?.thumbnail_2,
        };
        galleryArray.push(galleryObject);
      });
      setGoalStatementGallery(galleryArray);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getGoalStatementList();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <JournalImageList />
        </div>
      </div>
      <br></br>
      {goalStatementGallery.length > 0 && (
        <div className="row mb-md-5">
          <GoalGallerySlider data={goalStatementGallery} />
        </div>
      )}
      {goalStatementQuestions.length > 0 && (
        <div className="row mt-md-5">
          <div className="col-12">
            <JournalMessage replies={replies} data={goalStatementQuestions} />
          </div>
        </div>
      )}
    </div>
  );
}

export default JournalPrompts;
